var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{ref:"GalleryManageHotelList"})
}
var staticRenderFns = []

export { render, staticRenderFns }